const isJson = (object) => {
    try {
        JSON.parse(object);
    }
    catch {
        return false;
    }
    return true;
};

export { isJson };
